import * as React from "react";
const SvgWdl = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: 32, height: 32, fill: "#333f52" }), /* @__PURE__ */ React.createElement("text", { x: 16, y: 16, fontSize: "10px", dy: "0.25em", textAnchor: "middle", fill: "#fff", stroke: "#fff" }, "WDL"));
export {
  SvgWdl as ReactComponent
};
